import React from "react"
import { AddressFieldSets, FormSectionElements, FormSections, FormSubSections, FunctionDetail, ProgramContainer } from "../entities/formTemplateDataType";
import { Accordion, AccordionTab } from "primereact/accordion";
import { SubSectionComponent } from "../runtimeComponent/SubSectionComponent";
import { SelectButton } from "primereact/selectbutton";
import { User } from "../entities/User";
import { Panel } from "primereact/panel";
import Parser from 'html-react-parser';
import { Button } from "primereact/button";
import axios from "axios";
import DataUtils from "../utilities/DataUtils";
import { Steps } from "primereact/steps";
import { ConfirmDialog } from "primereact/confirmdialog";
import FormValidationUtils from "../utilities/FormValidationUtils";
import ReactDOMServer from 'react-dom/server';
import html2pdf from 'html2pdf.js';
import { Toast } from "primereact/toast";
import { MsalContext, MsalProvider } from "@azure/msal-react";
import { ErrorAlertsComponent } from "../runtimeComponent/odsCalloutBox/ErrorAlertsComponent";
import { SummaryComponent } from "../runtimeComponent/subComponent/SummaryComponent";
import { CustomizedSummaryComponent } from "../runtimeComponent/summary/CustomizedSummaryComponent";
import StepIndicator from "../runtimeComponent/subComponent/step-indicator/StepIndicator";
import { SpinnerComponent } from "../commonComponent/SpinnerComponent";
import { ProgressBar } from "primereact/progressbar";
import { gaCustomEvent, gaEvent } from "../utilities/GAUtils";
import { getQuizGaData, sendRatingAndFeedbackToGA, sendSummaryInfoToGA } from "../services/GADataUtils";
import { generateAndDownloadPDF } from "../services/PDFGenerationService";
import Utils from "../utilities/Utils";
import { focusOnFirstErrorElement, focusOnSectionHeader, needCxpProfile } from "../utilities/ElementUtils";
import SectionUtils from "../utilities/SectionUtils";
import { ElementComponent } from "../runtimeComponent/ElementComponent";
import HelmetComponent from "../commonComponent/HelmetComponent";
import { CMAFormComponent } from "./CMAFormComponent";
import SessionStorageService from "../services/SessionStorageService";
import { TOKEN_TYPE } from "../entities/Constants";

interface Props {
    programContainer: ProgramContainer;
    isEng: boolean;
    user?: User,
    hash?,
    callback: (programContainer: ProgramContainer) => void;
    callbackOriginalData;
    callBackLang: (isEng: boolean) => void
}

interface State {
    activeIndex,
    stepperIndex: number,
    isBusy: boolean;
    showConfirmationDialog: boolean;
    showReview: boolean;
    showForm: boolean;
    reviewButtonVisible: boolean;
    validationErrMsg: any;
    isComplete: boolean;
}

export class FormPreviewComponent extends React.Component<Props, State> {
    caseId;
    language: any;
    sectionArray: [];
    removingIndex;
    // validationErrMsg: any = [];
    sortedList: FormSections[];

    recaptcha: any;
    growl: Toast;
    continueButtonHidden;
    // NotStep:boolean;
    static contextType = MsalContext;
    gaTrackingId = this.props.programContainer?.GATrackingID
    activeStepList: Set<number>;
    returnIndex: number;

    constructor(props: Props) {
        super(props);

        this.state = {
            showConfirmationDialog: false,
            activeIndex: 0,
            stepperIndex: 0,
            isBusy: false,
            showForm: true,
            showReview: false,
            reviewButtonVisible: false,
            validationErrMsg: [],
            isComplete: false,
        }
        this.activeStepList = new Set<number>();
        //   this.activeStepList.add(0); //add the first page
        this.sortFormList();

    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        this.sortFormList();
        // if (!this.activeStepList) {
        //     this.activeStepList = new Set<number>();
        //     this.activeStepList.add(0); //add the first page
        // }
    }

    sortFormList = () => {
        if (this.props.programContainer != null) {
            this.sortedList = this.props.programContainer.ListOfFormSections?.sort((a, b) => a.Sequence - b.Sequence);
            this.sortedList?.forEach(async section => {
                // if (section.PreScript) {
                //     try {
                //         const customJSFunc = eval(`(${section.PreScript})`);
                //         // customJSFunc(section, process.env);
                //     } catch (ex) {
                //         console.log(ex);
                //     }
                // }
                section.findFieldByName = (fieldName) => {
                    const root = section.parent;

                    const formList = root.ListOfFormSections as FormSections[];
                    let eleReturned;
                    try {
                        formList.forEach(section => {

                            if (section.Visible == false) return;
                            section.ListOfFormSubSections.forEach(sub => {
                                const elements = sub.ListOfFormSectionElements;
                                elements.forEach(ele => {
                                    if (ele.LoadBindName == fieldName) {
                                        eleReturned = ele;
                                        throw new Error('Exit all loops');
                                    }
                                })
                            })
                        });
                    } catch {
                        return eleReturned;
                    }
                    return null;
                };
                section.findSectionByTitle = (sectionTitle) => {
                    const root = section.parent;

                    const formList = root.ListOfFormSections as FormSections[];
                    if (formList != null && formList.length > 0) {
                        for (var sec of formList) {
                            if (sec.ENUTitle == sectionTitle) {
                                return sec;
                            }
                        }
                    }

                    return null;
                };

                section.findSubsectionByTitle = (subsectionTitle) => {
                    return section.ListOfFormSubSections.find(subsection => subsection.ENUTitle == subsectionTitle);
                };
            })
        }
    }

    componentDidMount = () => {
        if (this.props.programContainer != null) {
            this.sortFormList();
            if (process.env.IS_RUNTIME == "true" || process.env.IS_RUNTIME == "deployed") {
                this.getCase();
            }
        }
    }

    getCase = async () => {

        let api = this.props.programContainer.GetAPI;
        let apiBase = this.props.programContainer.APIBasePath;
        let getUrl = apiBase + "/" + api;

        //java api transfers to destination
        if (getUrl != null) {

            let url = window.location.href;
            url = url.replace("/fr", "");
            const pathSegmentsAll = url.split('#');

            if (pathSegmentsAll.length > 1) {
                const pathSegments = pathSegmentsAll[1].split("/").filter(p => p != "");

                const segNumber = pathSegments.length;

                if (api == null || api == "") {
                    return;
                }

                const regex = /{[^{}]*}/g;
                const matches = api.match(regex);
                if (matches) {
                    let param1;
                    let param2;

                    switch (segNumber) {
                        case 1:
                            break;
                        case 2:
                            param1 = pathSegments[segNumber - 1];
                            getUrl = getUrl.replace(matches[0], param1);
                            getUrl = getUrl.replace(matches[1], "");
                            this.props.programContainer[matches[0].replace("{", '').replace("}", '')] = param1;
                            break;
                        case 3:
                            param1 = pathSegments[segNumber - 2];
                            param2 = pathSegments[segNumber - 1];
                            getUrl = getUrl.replace(matches[0], param1).replace(matches[1], param2);

                            this.props.programContainer[matches[0].replace("{", '').replace("}", '')] = param1;
                            this.props.programContainer[matches[1].replace("{", '').replace("}", '')] = param2;
                            break;
                    }
                }
            }

            let response = null;

            if (this.props.programContainer.UseProxy == "Y") {
                console.log("load data")
                let transferPayload = {
                    url: getUrl,
                    httpMethod: 'GET',
                    payload: ""
                }
                const headers = {
                    'Content-Type': 'application/json',
                    'ApplicationId': this.props.programContainer.CategoryId
                };

                response = await axios.post(process.env.LAYOUT_API_URL + "/transfer", transferPayload, { headers: headers });

            } else {
                if (this.props.programContainer.AuthRequired === "ad") {
                    // const msalInstance = this.context["instance"];
                    // const msalAccounts = this.context["accounts"];
                    // const msalInProgress = this.context["inProgress"];
                    // const responseToken = await msalInstance.acquireTokenSilent({
                    //     scopes: [`api://${process.env.clientId}/Files.Read`],
                    //     account: msalAccounts[0],
                    // });
                    const accessToken = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
                    response = await axios.get(getUrl, {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        }
                    },)
                }
            }
            const data = response.data;
            this.props.programContainer.Entity=response.data;
            DataUtils.assignFormValue(this.props.programContainer);
            this.props.programContainer.IsComplete = data.IsComplete == true || data.IsComplete == 'Y';
            this.props.callback(this.props.programContainer);
            this.props.callbackOriginalData(data);
            // this.setState({programContainer:this.props.programContainer});
            this.setState({ isComplete: data.IsComplete })
            if (data != null && data.IsComplete != null && (data.IsComplete == true || data.IsComplete == 'Y')) {
                DataUtils.makeCompoenentReadonly(this.props.programContainer);
            }
        }
    }

    previewForm = () => {
        let panelContents = [];
        let tabPanelContents = [];
        const options = ['English', 'French'];
        if (this.props.programContainer == null) return null;
        this.sortFormList();

        if (this.props.programContainer.Instructions && this.props.programContainer.Instructions.trim() != "" && this.props.programContainer.Instructions.trim() != "<p><br></p>") {
            tabPanelContents.push(
                <>
                    <AccordionTab key="panel_instructions" header="Instructions" >
                        <div>
                            {this.props.programContainer != null && this.props.programContainer.Instructions != null ? Parser(this.props.programContainer.Instructions) : null}
                        </div>
                    </AccordionTab>
                </>
            );
        }

        if (this.sortedList) {
            for (let formSection of this.sortedList) {
                let panelCaption: string = this.props.isEng ? formSection.ENUTitle : formSection.FRATitle;
                let addtionalComments: string = this.props.isEng ? formSection.ENUDescription : formSection.FRADescription;

                if (formSection.ListOfFormSubSections.length == 1) {
                    let subSection = formSection.ListOfFormSubSections[0];

                    tabPanelContents.push(
                        <>
                            {/* @ts-ignore */}
                            <AccordionTab key={"AccordionTab_panel_" + subSection.ENUTitle} header={panelCaption} >
                                <p style={{ display: formSection.ENUDescription ? 'block' : 'none' }}>{addtionalComments}</p>
                                {/* {this.props.programContainer.OntarioChat ?
                                <OntarioChatComponent currentSection={formSection} lang={this.props.isEng ? 'en' : 'fr'}/> : null
                            } */}
                                <SubSectionComponent key={'sub_' + formSection.Id + subSection.Id} isEng={this.props.isEng} {...this.props}
                                    // renderHeader={this.props.programContainer.displayForm !== 'NoIndicatorStepper'}
                                    activeSubSection={subSection} user={this.props.user} editable={true} topEntity={formSection.Value}
                                    roleBasedEditable={true} roleBased={false} ownerEditableOnly={false}
                                    callbackValidate={(errors) => {
                                        this.setState({ validationErrMsg: errors }, () => { window.scrollTo({ top: 0, behavior: 'smooth' }); });
                                    }}
                                    callbackStepIndex={(stepperIndex, returnIndex) => {
                                        // this.sortedList=this.props.programContainer.ListOfFormSections;
                                        this.returnIndex = returnIndex;
                                        let section;
                                        if (typeof stepperIndex == 'number') {
                                            section = this.sortedList[stepperIndex];
                                        } else {
                                            section = stepperIndex
                                        }

                                        if (!section.IsInfoPage && !section.IsTechErrorPage && !section.IsConfirmationPage)
                                            this.activeStepList.add(stepperIndex);
                                        this.setState({ stepperIndex: stepperIndex });
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }}
                                    callback={(programContainer) => {
                                        this.props.callback(programContainer)
                                        // this.callBackFromDetailForm(subSection);
                                    }} />
                                {/* {this.addButton(formSection, subSection, 1)} */}
                            </AccordionTab>
                        </>
                    );
                } else {
                    let multiplePanel = [];
                    multiplePanel.push(
                        <>
                            <p style={{ display: formSection.ENUDescription ? 'block' : 'none' }}>{addtionalComments}</p>
                            {/* {this.props.programContainer.OntarioChat && (
                            <OntarioChatComponent currentSection={formSection} lang={this.props.isEng ? 'en' : 'fr'}/>
                        )} */}
                        </>
                    );

                    formSection.ListOfFormSubSections.sort((a, b) => a.Sequence - b.Sequence)
                        .forEach((subSection, subIndex) => {

                            let panelCaption: string = this.props.isEng ? subSection.ENUTitle : subSection.FRATitle;
                            if (panelCaption == null) {
                                panelCaption = formSection.ENUTitle + ' ' + subSection.Sequence;
                            }
                            multiplePanel.push(
                                <div>
                                    {/* @ts-ignore */}
                                    <Panel key={"multiplePanel_panel_" + subSection.ENUTitle} header={panelCaption} toggleable style={{ marginBottom: '10px' }}>
                                        <SubSectionComponent key={'sub_' + subSection.Id} isEng={this.props.isEng}
                                            {...this.props}
                                            activeSubSection={subSection} renderHeader={this.props.programContainer.displayForm !== 'NoIndicatorStepper'}
                                            user={this.props.user} editable={true} topEntity={{}}
                                            roleBasedEditable={true} roleBased={false}
                                            callbackValidate={(errors) => {
                                                this.setState({ validationErrMsg: errors }, () => { window.scrollTo({ top: 0, behavior: 'smooth' }); });
                                            }}
                                            callbackStepIndex={(stepperIndex, returnIndex) => {
                                                // this.sortedList=this.props.programContainer.ListOfFormSections;
                                                console.log("stepperIndex", stepperIndex);
                                                this.returnIndex = returnIndex;
                                                const section = this.sortedList[stepperIndex];
                                                if (!section.IsInfoPage && !section.IsTechErrorPage && !section.IsConfirmationPage)
                                                    this.activeStepList.add(stepperIndex);
                                                this.setState({ stepperIndex: stepperIndex });
                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                            }
                                            }
                                            ownerEditableOnly={false} callback={(programContainer) => {
                                                this.props.callback(programContainer);
                                                // this.callBackFromDetailForm(subSection);
                                            }

                                            }
                                        />
                                    </Panel>
                                    {/* {this.addButton(formSection, subSection, subIndex + 1)} */}
                                </div>
                            );
                        });
                    tabPanelContents.push(
                        <>
                            <AccordionTab
                                key={"AccordionTab_panel_" + formSection.ENUTitle} header={panelCaption} >
                                {multiplePanel}
                            </AccordionTab>
                        </>
                    )
                }
            };
        }


        panelContents.push(
            <div style={{ width: '100%' }} >
                <HelmetComponent title={this.props.programContainer?.AppTitle?.[this.props.isEng ? 'en' : 'fr'] || document.title} />
                <div style={{ display: process.env.IS_RUNTIME != 'false' || this.props.programContainer.EnglishOnly ? 'none' : 'flex', justifyContent: 'end', marginBottom: '20px' }} >
                    {/* @ts-ignore */}
                    <SelectButton value={this.props.isEng ? 'English' : 'French'} onChange={(e) => this.props.callBackLang(e.value == 'English')} options={options} />
                </div>
                {/* <div className='form-header' key="ENUTitle" >
                    {this.props.isEng ? this.props.formSection.ENUTitle : this.props.formSection.FRATitle}
                </div> */}

                <div style={{ display: 'flex', marginBottom: '20px', marginTop: '10px' }} >
                    {/* @ts-ignore */}
                    <Button label="Expand" className="p-button-text"
                        onClick={() => {
                            let list = this.props.programContainer.ListOfFormSections;
                            let activeIndex = [];
                            for (var i = 0; i <= list.length; i++) {
                                activeIndex[i] = i;
                            }
                            this.setState({ activeIndex: activeIndex });
                        }} />
                    {/* @ts-ignore */}
                    <Button label="Collapse" className="p-button-outlined p-button-secondary" style={{ marginLeft: '5px', border: '1px solid grey', color: 'grey' }}
                        onClick={() => {
                            let activeIndex = this.state.activeIndex;
                            activeIndex = []; // Set all elements to false (expanded)
                            this.setState({ activeIndex: activeIndex });
                        }} />
                </div>

                <div>
                    {/* @ts-ignore */}
                    <Accordion multiple key="accordion" style={{ width: '100%', height: '100%', justifyContent: 'center' }} activeIndex={this.state.activeIndex}
                        onTabChange={(e) => { this.setState({ activeIndex: e.index });; console.log(this.state.activeIndex) }}
                        onTabOpen={(e) => { window.scrollTo(e.originalEvent.clientX, e.originalEvent.clientY) }}>
                        {tabPanelContents}
                    </Accordion>
                </div>
                <div>
                    <SpinnerComponent isBusy={this.state.isBusy} />
                </div>
            </div>

        );

        return panelContents;
    }

    stepperHeaderGeneration = () => {
        let items;// = this.hideSection();
        let StepperHeader = [];
        const options = ["English", "French"];

        const currentSection = this.sortedList[this.state.stepperIndex];

        const displayErrorCompoenent = this.state.validationErrMsg.filter(p => p.Visible).length > 0;

        switch (this.props.programContainer.displayForm) {
            case 'stepper':
                StepperHeader.push(
                    <div style={{ width: '100%' }}>
                        <div style={{ display: process.env.IS_RUNTIME !== 'false' || this.props.programContainer.EnglishOnly ? 'none' : 'flex', justifyContent: 'end', marginBottom: '20px' }} >
                            {/* @ts-ignore */}
                            <SelectButton value={this.props.isEng ? 'English' : 'French'} onChange={(e) => this.props.callBackLang(e.value == 'English')} options={options} />
                        </div>

                        <div style={{ marginBottom: "7%" }} className="card">
                            {/* @ts-ignore */}
                            <Steps model={items} activeIndex={this.state.stepperIndex} onSelect={(e) => this.setState({ stepperIndex: e.index })} readOnly={false} />
                        </div>
                        <div style={{ display: displayErrorCompoenent ? "block" : "none" }}>
                            <ErrorAlertsComponent errorMsgList={this.state.validationErrMsg} isEng={this.props.isEng} ></ErrorAlertsComponent>
                        </div>
                        <hr></hr>

                        <div>
                            <SpinnerComponent isBusy={this.state.isBusy} />
                        </div>
                    </div>
                );
                break;
            case 'hiddenStepper':
                if (!currentSection?.IsTechErrorPage) {
                    const topPositionFields = SectionUtils.getFieldsAboveTitle(currentSection);
                    const element = topPositionFields.length > 0 ? topPositionFields[0] : null;
                    StepperHeader.push(
                        <div style={{ width: '100%' }}>
                            <div style={{ display: process.env.IS_RUNTIME !== 'false' || this.props.programContainer.EnglishOnly ? 'none' : 'flex', justifyContent: 'end', marginBottom: '20px' }} >
                                {/* @ts-ignore */}
                                <SelectButton value={this.props.isEng ? 'English' : 'French'} onChange={(e) => this.props.callBackLang(e.value == 'English')} options={options} />
                            </div>
                            <div>
                                <div style={{ display: currentSection?.IsInfoPage || currentSection?.CustomizedReviewPage || currentSection?.IsTechErrorPage ? "none" : "block" }}>
                                    <StepIndicator withbackbtn={true} sectionSequence={this.state.stepperIndex}
                                        title="Back" section={currentSection} isEng={this.props.isEng}
                                        totalSteps={this.activeStepList}
                                        callback={(currentStep, totalSteps) => {
                                            if (currentStep == undefined) {
                                                this.setState({ stepperIndex: 0, validationErrMsg: [] })
                                            } else {
                                                this.setState({ stepperIndex: currentStep, validationErrMsg: [] })
                                            }
                                            this.activeStepList = totalSteps;
                                        }}>
                                    </StepIndicator>
                                </div>

                                <div>
                                    {element && <ElementComponent
                                        key={element.LoadBindName + '_ElementComponent_field_' + element.Id}
                                        isEng={this.props.isEng}
                                        field={element}
                                        editable={true}
                                        callbackElement={(container) => {
                                            this.props.callback(container);
                                        }}
                                    />}
                                </div>

                                <div style={{ display: displayErrorCompoenent ? "block" : "none" }}>
                                    <ErrorAlertsComponent errorMsgList={this.state.validationErrMsg} isEng={this.props.isEng} ></ErrorAlertsComponent>
                                </div>
                                {/* <div style={{ display: currentSection?.IsTerminationPage || currentSection?.IsConfirmationPage || currentSection.CustomizedReviewPage ? "none" : "block" }} */}
                                {!currentSection?.TitleInStepIndicator && <><div style={{ display: currentSection?.IsTerminationPage || currentSection.CustomizedReviewPage ? "none" : "block" }} className="ontario-h1 ontario-margin-bottom-0-!">{this.props.isEng ? currentSection?.ENUTitle : currentSection?.FRATitle}</div>

                                <div style={{ display: currentSection?.IsTerminationPage || currentSection.CustomizedReviewPage ? "none" : "block" }}
                                    className={!currentSection?.IsTerminationPage && currentSection?.ENUDescription ? "ontario-margin-top-24-!" : ""}>
                                    {this.props.isEng ? currentSection?.ENUDescription : currentSection?.FRADescription}
                                </div></>}
                            </div>
                            <div>
                                <SpinnerComponent isBusy={this.state.isBusy} />
                            </div>
                        </div>
                    );
                }

                break;
            case 'hiddenStepperWithSectionTitle':
                if (!currentSection.NotStep) {
                    StepperHeader.push(
                        <div className="ontario-margin-top-16-!" style={{ width: '100%' }}>
                            <div style={{ display: process.env.IS_RUNTIME !== 'false' || this.props.programContainer.EnglishOnly ? 'none' : 'flex', justifyContent: 'end', marginBottom: '20px' }} >
                                {/* @ts-ignore */}
                                <SelectButton value={this.props.isEng ? 'English' : 'French'} onChange={(e) => this.props.callBackLang(e.value == 'English')} options={options} />
                            </div>

                            <div>
                                <span className="ontario-h4" style={{ display: !currentSection?.IsFrontPage && !currentSection?.IsTerminationPage && !currentSection?.CustomizedReviewPage && !currentSection?.IsTechErrorPage ? "block" : "none" }} >
                                    Step&nbsp;
                                    {this.state.stepperIndex + 1}&nbsp;of&nbsp;
                                    {this.props.programContainer.ListOfFormSections.filter(p => !p.IsFrontPage && !p.IsTerminationPage && !p.CustomizedReviewPage && p.Visible).length}:&nbsp;
                                    {this.props.isEng ? this.sortedList[this.state.stepperIndex]?.ENUTitle :
                                        this.sortedList[this.state.stepperIndex]?.FRATitle}

                                </span>
                                <hr className="ontario-margin-top-0-! ontario-margin-bottom-36-!" />
                            </div>


                            <div style={{ display: displayErrorCompoenent ? "block" : "none" }}>
                                <ErrorAlertsComponent errorMsgList={this.state.validationErrMsg} isEng={this.props.isEng} ></ErrorAlertsComponent>
                            </div>
                            <div>
                                <SpinnerComponent isBusy={this.state.isBusy} />
                            </div>
                        </div>
                    );
                }
                break;
            case 'NoIndicatorStepper':
                StepperHeader.push(
                    <div style={{ width: '100%' }}>
                        {/* <StepIndicator withbackbtn={true} currentStep={currentSection.NotStep ? 0 : this.state.stepperIndex} 
                            title="Back" section={currentSection} isEng={this.props.isEng}
                                totalSteps={totalSteps}
                                callback={(currentStep) => { this.setState({ stepperIndex: currentStep, validationErrMsg:[] }) }}>
                            </StepIndicator> */}
                        <br></br>
                        <div style={{ display: process.env.IS_RUNTIME !== 'false' || this.props.programContainer.EnglishOnly ? 'none' : 'flex', justifyContent: 'end', marginBottom: '20px' }} >
                            {/* @ts-ignore */}
                            <SelectButton value={this.props.isEng ? 'English' : 'French'} onChange={(e) => this.props.callBackLang(e.value == 'English')} options={options} />
                        </div>
                    </div>
                );
                break;
            case 'progressBarStepper':
                const stepSections = this.props.programContainer.ListOfFormSections
                    .filter(p => !p.CustomizedReviewPage && !p.IsTechErrorPage);
                if (stepSections.length <= 1) return null;

                let progress = Math.round(100 * (this.state.stepperIndex) / (stepSections.length-1))
                if (progress > 100) {
                    progress = 100;
                }
                if (progress > 0) {
                    StepperHeader.push(
                        <div style={{ width: '100%' }} className="ontario-margin-top-16-!">
                            <div style={{ display: process.env.IS_RUNTIME !== 'false' || this.props.programContainer.EnglishOnly ? 'none' : 'flex', justifyContent: 'end', marginBottom: '20px' }} >
                                {/* @ts-ignore */}
                                <SelectButton value={this.props.isEng ? 'English' : 'French'} onChange={(e) => this.props.callBackLang(e.value == 'English')} options={options} />
                            </div>
                            {/* @ts-ignore */}
                            <ProgressBar
                                title={this.props.isEng ? `current progress: ${progress}` : `Progrès en cours : ${progress}`}
                                value={progress}
                                aria-valuetext={`Loading: ${progress}% complete`}
                            // displayValueTemplate={() => `${currentStep}/${stepSections.length}`}
                            />
                            <hr className="progressbar-separater" />
                            <div style={{ display: displayErrorCompoenent ? "block" : "none" }}>
                                <ErrorAlertsComponent errorMsgList={this.state.validationErrMsg} isEng={this.props.isEng} ></ErrorAlertsComponent>
                            </div>
                        </div>
                    );
                }
                break;
        }

        return StepperHeader;
    }

    determineSectionVisibility = () => {

        outerLoop: for (let formSection of this.sortedList) {
            formSection.Visible = true;
            let currentFilterValue = this.props.isEng ? formSection.FilterValue : formSection.FilterValueFRA;
            if (currentFilterValue?.length > 0 && Utils.isNotNullOrEmpty(currentFilterValue?.filter(p => p?.length > 0))) {
                let priorSectionList = this.props.programContainer.ListOfFormSections.filter(p => p.Sequence < formSection.Sequence).sort((a, b) => a.Sequence - b.Sequence);
                middleLoop: for (let priorSection of priorSectionList) {
                    for (let i = 0; i < formSection.FilterField.length; i++) {
                        const ele = priorSection.findFieldByName(formSection.FilterField[i]);
                        if (ele && ele.Value && formSection.FilterValue[i]?.length > 0) {
                            if (!formSection.FilterValue[i].includes(ele.Value)) {
                                formSection.Visible = false;
                                break middleLoop;
                            }
                        }
                    }
                }
            }

            // if (formSection && formSection.Visible && formSection.PreScript && formSection.PreScript?.trim().length > 0) {
            //     const customJSFunc = eval(`(${formSection.PreScript})`);
            //     try {
            //         customJSFunc(formSection);
            //     } catch (ex) {
            //         console.log(ex);
            //     }
            // }
            this.execuetPreScript(formSection)
        }
    }


    previewFormInStepper = () => {
        let stepperBody = [];
        let stepperContent = [];

        if (this.props.programContainer != null)
            this.sortFormList();

        if (this.sortedList.length == 0) return null;

        // const visibleSections = this.sortedList.filter(p => p.Visible);

        // if (visibleSections.length == 0) return null;

        const lastVisibleSection = this.sortedList[this.sortedList.length - 1];

        const currentSection = this.sortedList[this.state.stepperIndex];
        if (!currentSection?.Visible) {
            this.setState({ stepperIndex: this.state.stepperIndex + 1 });
            return null;
        }
        this.continueButtonHidden = lastVisibleSection?.Sequence == currentSection?.Sequence;

        if (currentSection != null) {
            //   console.log(currentSection)
            stepperBody.push(<HelmetComponent title={this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle} />)
            if (currentSection.CustomizedReviewPage) {
                stepperBody.push(this.generateReviewHtmlString());

            } else {
                stepperContent.push(this.stepperHeaderGeneration());
                const subsectionNumber = currentSection.ListOfFormSubSections.length;
                currentSection.ListOfFormSubSections.sort((a, b) => a.Sequence - b.Sequence)
                    .forEach((subSection, sectionIndex) => {
                        let subsectionHtmlString = [];

                        subsectionHtmlString.push(
                            <SubSectionComponent key={'sub_' + subSection.Id} isEng={this.props.isEng}
                                {...this.props}
                                activeSubSection={subSection}
                                returnIndex={this.returnIndex}
                                user={this.props.user} editable={true} renderHeader={this.props.programContainer.displayForm !== 'NoIndicatorStepper'}
                                callback={(programContainer) => {
                                    this.props.callback(programContainer)
                                }}
                                callbackValidate={(errors) => {
                                    this.setState({ validationErrMsg: errors }, () => {
                                        this.props.callback(this.props.programContainer);
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                    });
                                }}
                                callbackStepIndex={(stepperIndex, returnIndex) => {
                                    this.returnIndex = returnIndex;
                                    const section = this.sortedList[stepperIndex];
                                    if (!section.IsInfoPage && !section.IsTechErrorPage && !section.IsConfirmationPage) {
                                        this.activeStepList.add(stepperIndex);
                                    }

                                    this.setState({ validationErrMsg: [], stepperIndex: stepperIndex, showForm: true }, () => {
                                        this.props.callback(this.props.programContainer);
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                    });
                                }} />
                        )

                        if (subsectionNumber > 1 && subsectionHtmlString.length > 0) {
                            stepperBody.push(
                                <div>
                                    {/* @ts-ignore */}
                                    <Panel header={subSection.ENUTitle} toggleable>
                                        {subsectionHtmlString}
                                    </Panel>
                                </div>
                            );
                        } else {
                            stepperBody.push(subsectionHtmlString);
                        }
                    }
                    );
            }

        }

        stepperContent.push(stepperBody);

        return stepperContent;
    }

postScript=async (currentSection)=>{
    if (currentSection?.PostScript) {
        const customJSFunc = eval(`(${currentSection.PostScript})`);
        const returnedValue = await customJSFunc(currentSection, process.env);
        console.log(returnedValue)
        if (typeof returnedValue == "boolean") {
            if (!returnedValue) {
                this.props.callback(this.props.programContainer);
                return;
            }
        }
        if (typeof returnedValue == "number") {
            this.setState({ validationErrMsg: [], stepperIndex: returnedValue }, () => {
                this.props.callback(this.props.programContainer);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
            return;
        }
        if (typeof returnedValue == "string") {
            const returnPageIndex = this.props.programContainer.ListOfFormSections.filter(p => p.ENUTitle == returnedValue)[0].Sequence - 1;
            this.setState({ validationErrMsg: [], stepperIndex: returnPageIndex }, () => {
                this.props.callback(this.props.programContainer);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });

            return;
        }
    }
}
    continueBtn = () => {
        if (this.props.programContainer != null)
            this.sortFormList();

        const currentSection = this.sortedList[this.state.stepperIndex];

        if (!currentSection ||
            currentSection?.NotStep ||
            [
                'IsTechErrorPage',
                'IsTerminationPage',
                'IsFrontPage',
                'IsInfoPage',
                'IsConfirmationPage'
            ].some(key => currentSection[key])) {
            return null;
        }
        let stepperIndex = this.state.stepperIndex;
        return (
            <>
                <div className="ontario-margin-top-32-!">
                    <button
                        className="ontario-button ontario-button--primary"
                        onClick={async () => {
                            await this.postScript(currentSection);                        

                            if (!currentSection.IsTerminationPage) {
                                let invalidControlList = FormValidationUtils.invalidControls(currentSection);
                                if (invalidControlList.length > 0) {
                                    this.setState({ validationErrMsg: invalidControlList }, () => { window.scrollTo({ top: 0, behavior: 'smooth' }); });
                                } else {
                                    let nextSection: FormSections;
                                    this.determineSectionVisibility();
                                    for (let i = 0; i < 10; i++) {
                                        stepperIndex++;

                                        nextSection = this.sortedList[stepperIndex];

                                        if (!nextSection && !SectionUtils.HasCustimzedSummary(this.props.programContainer)) {
                                            this.setState({ showForm: false, showReview: true });
                                            break;
                                        }

                                        // if (nextSection && nextSection.PreScript && nextSection.PreScript.trim().length > 0) {

                                        //     const customJSFunc = eval(`(${nextSection.PreScript})`);
                                        //     console.log(customJSFunc);
                                        //     customJSFunc(nextSection);
                                        // }

                                        this.execuetPreScript(nextSection);

                                        if (nextSection?.CustomizedReviewPage) {
                                            this.activeStepList.add(stepperIndex);
                                            this.setState({ showReview: true, showForm: false });
                                            break;
                                        }
                                        if (nextSection?.Visible) {
                                            this.activeStepList.add(stepperIndex);
                                            this.setState({ validationErrMsg: [], stepperIndex: stepperIndex }, () => {
                                                this.props.callback(this.props.programContainer);
                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                            });
                                            break;
                                        }
                                    }


                                    gaEvent({
                                        action: 'click',
                                        category: 'Continue',
                                        label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle,
                                    }, this.gaTrackingId);
                                }
                                await this.postScript(currentSection);
                            }
                        }}>
                        {
                            this.props.isEng ?
                                currentSection?.NextButtonLabel ? currentSection?.NextButtonLabel : "Continue"
                                : currentSection?.NextButtonLabelFRA ? currentSection?.NextButtonLabelFRA : "Continuer"
                        }
                    </button>
                </div>
            </>
        );
    }

    execuetPreScript = (formSection) => {
        if (formSection && formSection.Visible && formSection.PreScript && formSection.PreScript?.trim().length > 0) {
            const customJSFunc = eval(`(${formSection.PreScript})`);
            try {
                customJSFunc(formSection);
            } catch (ex) {
                console.log(ex);
            }
        }
    }

    stepperBtn = () => {
        let currentSection = this.sortedList[this.state.stepperIndex];
        return <div style={{ display: currentSection?.IsFrontPage ? 'none' : 'flex', justifyContent: 'space-between' }}>
            <button
                className="ontario-button ontario-button--secondary"
                style={{ visibility: this.state.stepperIndex == 0 ? 'hidden' : 'visible' }}
                onClick={() => {
                    let stepperIndex = this.state.stepperIndex;
                    this.setState({ validationErrMsg: [] });
                    let prevSection: FormSections;
                    for (let i = 0; i < 6; i++) {
                        stepperIndex--;
                        prevSection = this.sortedList[stepperIndex];
                        if (prevSection.Visible) {
                            break;
                        }
                    }
                    this.setState({ stepperIndex: stepperIndex }, () => {
                        const firstHeader = document.querySelector('h1');
                        // Check if an <h1> element was found and focus on it
                        if (firstHeader) {
                            firstHeader.focus();
                        }
                    });
                    gaEvent({
                        action: 'click',
                        category: 'Step Back',
                        label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle,
                    }, this.gaTrackingId);
                }}>
                {this.props.isEng ? "Back" : "Précédent"}
            </button>

            <button
                className="ontario-button ontario-button--secondary"
                style={{ display: (this.state.isComplete || this.EditableFieldsInForm() == false) || this.props.programContainer.NoClearButton == "Y" ? 'none' : 'block' }}
                onClick={() => {
                    let stepperIndex = this.state.stepperIndex;
                    currentSection = this.sortedList[stepperIndex];
                    this.clearCurretForm();
                    this.props.callback(this.props.programContainer);
                }}>
                {this.props.isEng ? "Clear" : "Vider"}
            </button>

            <button
                className="ontario-button ontario-button--secondary"
                style={{ display: this.state.isComplete || this.props.programContainer.HasSaveDraftButton != 'Y' ? 'none' : 'block' }}
                onClick={() => {
                    this.saveToServer(false);
                }}>
                {this.props.isEng ? "Save a draft" : "Enregistrer un brouillon"}
            </button>

            <button
                className="ontario-button ontario-button--primary"
                style={{ display: (this.continueButtonHidden && this.props.programContainer.NoReview !== 'Y') || currentSection.IsTerminationPage ? 'none' : 'block' }}
                onClick={() => {
                    this.nextClickHandler(currentSection);
                }}>
                {currentSection.IsTerminationPage ? (
                    this.props.isEng ? 'Leave Application' : 'Quitter'
                ) : (
                    this.props.isEng ? 'Next' : 'Suivant'
                )}
            </button>

            <a className="ontario-button ontario-button--primary" href={this.props.isEng ? (this.props.programContainer.RedirectURL || process.env.SERVICEONTARIO_URL) : (this.props.programContainer.RedirectURLFRA || process.env.SERVICEONTARIO_URL_F)} rel="noreferrer"
                style={{ display: currentSection.IsTerminationPage ? 'block' : 'none' }}
                onClick={() => {
                    this.nextClickHandler(currentSection);
                }}>
                {this.props.isEng ? 'Leave Application' : 'Quitter'}
            </a>
            <div style={{
                display: (this.state.showForm && "Y" !== this.props.programContainer.NoReview)
                    && true !== currentSection.IsTerminationPage && this.state.stepperIndex == this.sortedList.length - 1 ? "block" : "none"
            }}>
                <button className="ontario-button ontario-button--primary"
                    onClick={(e) => {
                        currentSection = this.sortedList[this.state.stepperIndex];
                        let invalidControlList = FormValidationUtils.invalidControls(currentSection);
                        if (invalidControlList.length > 0) {
                            this.setState({ validationErrMsg: invalidControlList });
                        } else {
                            this.setState({ showReview: true, showForm: false });
                            window.scrollTo(0, 0);
                        }
                        gaEvent({
                            category: 'Review',
                            action: 'Click',
                            label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle
                        }, this.gaTrackingId);
                    }}>
                    {this.props.isEng ? "Review" : "Révision"}
                </button>
            </div>
        </div>
    }

    nextClickHandler = (currentSection) => {
        let stepperIndex = this.state.stepperIndex;

        if (currentSection.PostScript) {
            const customJSFunc = eval(`(${currentSection.PostScript})`);
            const returnedValue = customJSFunc(currentSection, process.env);
            if (typeof returnedValue == "boolean") {
                if (!returnedValue) {
                    this.props.callback(this.props.programContainer);
                    return;
                }
            }
            if (typeof returnedValue == "number") {
                this.setState({ stepperIndex: returnedValue });
                this.props.callback(this.props.programContainer);
                return;
            }
        }

        if (currentSection.IsTerminationPage) {
            this.setState({ validationErrMsg: [], stepperIndex: 0 });
            sendRatingAndFeedbackToGA(currentSection, this.gaTrackingId, this.props.isEng ? 'en' : 'fr');
            sendSummaryInfoToGA(currentSection, this.props.isEng ? 'en' : 'fr');
            // window.location.replace('https://www.ontario.ca/page/serviceontario');
            return null;
        } else {

            currentSection = this.sortedList[stepperIndex];
            // this.scanCurretForm();
            let invalidControlList = FormValidationUtils.invalidControls(currentSection);
            if (invalidControlList.length > 0) {
                this.setState({ validationErrMsg: invalidControlList }, () => {
                    const firstHeader = document.querySelector('#error-container') as HTMLDivElement;
                    if (firstHeader) {
                        firstHeader.focus();
                    } else {
                        focusOnFirstErrorElement();
                    }
                });
            } else {
                //if GA tracking is needed we track each page
                const value = this.props.programContainer.sendPageDataToGA ? getQuizGaData(currentSection, this.props.isEng ? 'en' : 'fr') : undefined;
                const label = this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle;
                if (!value) {
                    gaEvent({
                        category: 'Next',
                        action: 'Click',
                        label: label,
                    }, this.gaTrackingId);
                } else {
                    gaCustomEvent('Go to next page', {
                        label: label,
                        [label + ': expected values']: value.expectedValues.join(', ') ?? '',
                        [label + ': exact values']: value.exactValues.join(', '),
                    }, this.gaTrackingId);
                }

                let nextSection: FormSections;
                for (let i = 0; i < 10; i++) {
                    stepperIndex++;
                    nextSection = this.sortedList[stepperIndex];
                    if (nextSection.Visible) {
                        this.props.callback(this.props.programContainer)
                        break;
                    } else {

                    }
                }
                this.setState({ validationErrMsg: [], stepperIndex: stepperIndex }, () => {
                    const firstHeader = document.querySelector('h1');
                    // Check if an <h1> element was found and focus on it
                    if (firstHeader) {
                        firstHeader.focus();
                    }
                });
            }
        }
    }

    clearCurretForm = () => {
        let currentSection = this.sortedList[this.state.stepperIndex];
        currentSection.ListOfFormSubSections.forEach(sub => {
            sub.ListOfFormSectionElements.forEach(ele => {
                if (typeof ele.Value === 'object' && ele.Value !== null) {
                    ele.Value = new AddressFieldSets();
                } else {
                    if (ele.Datatype !== "Label")//never clear lable as its purpose is for display 
                        ele.Value = '';
                    if (ele.Datatype == "SelectWithRichText") {
                        ele.SelectionCode = "";
                        ele.Value = ""
                    }
                }
            })
        });
        gaEvent({
            action: 'click',
            category: 'ClearForm',
            label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle,
        }, this.gaTrackingId);
    }

    EditableFieldsInForm = () => {
        let currentSection = this.sortedList[this.state.stepperIndex];
        let res = false;
        currentSection.ListOfFormSubSections.forEach(sub => {
            sub.ListOfFormSectionElements.forEach(ele => {
                if (ele.Editable == 'Y' && ele.Datatype != 'Label' && ele.Datatype != 'HTML') {
                    res = true;
                }
            })
        });

        return res;
    }


    addSubmitAndReview = () => {
        const currentSection = this.sortedList[this.state.stepperIndex];

        return (
            <div style={{ marginTop: '0px', display: 'flex', alignItems: 'stretch', float: "right" }}>
                {/* <div style={{ display: (this.state.showForm && "Y" !== this.props.programContainer.NoReview) && true !== currentSection.IsTerminationPage ? "block" : "none" }}>
                    <button className="ontario-button ontario-button--primary"
                        onClick={(e) => {
                            currentSection = this.sortedList.filter(p=>p.Visible)[this.state.stepperIndex];
                            let invalidControlList = FormValidationUtils.invalidControls(currentSection);
                            if (invalidControlList.length > 0) {
                                this.setState({ validationErrMsg: invalidControlList });
                            } else {
                                this.setState({ showReview: true, showForm: false });
                                window.scrollTo(0, 0);
                            }
                            gaEvent({
                                category: 'Review',
                                action: 'Click',
                                label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle
                            }, this.gaTrackingId);
                        }}>
                        {this.props.isEng ? "Review" : "Révision"}
                    </button>
                </div> */}

                <div style={{ display: this.state.showForm && this.props.programContainer.displayForm !== 'panel' ? "none" : "flex" }} className="ontario-padding-top-24-!">
                    <button className="ontario-button ontario-button--secondary"
                        onClick={(e) => {
                            this.setState({ showReview: false, showForm: true });
                            window.scrollTo(0, 0);
                            gaEvent({
                                action: 'click',
                                category: this.state.isComplete ? 'Back' : 'Edit',
                                label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle
                            }, this.gaTrackingId);
                        }}>
                        {(this.state.isComplete) ? (
                            this.props.isEng ? 'Back' : 'Écran précédent'
                        ) : (
                            this.props.isEng ? 'Edit' : 'Modifier'
                        )}
                    </button>

                    <button className="ontario-button ontario-button--secondary"
                        onClick={(e) => {
                            if (this.props.programContainer.pdfTemplate) {
                                generateAndDownloadPDF(this.props.programContainer);
                            } else {
                                this.downloadPDF2();
                            }

                        }}>
                        {this.props.isEng ? "Download PDF" : "Télécharger le PDF"}
                    </button>

                    <button className="ontario-button ontario-button--primary"
                        style={{ display: this.state.isComplete || false ? 'none' : 'block' }}
                        onClick={(e) => { this.saveToServer(true) }}>
                        {this.props.isEng ? "Submit" : "Envoyer"}
                    </button>
                </div>
            </div>
        )
    }

    //Download pdf html2pdf version
    downloadPDF2 = () => {
        const pdfJSX = () => {
            return (
                <div style={{ display: "block : none", margin: "25px 15px" }}>
                    {this.generateReviewHtmlString(true)}
                </div>
            )
        }
        const printElement = ReactDOMServer.renderToString(pdfJSX());
        const fileName = this.props.programContainer.CategoryId
        const options = {
            pagebreak: {
                mode: "avoid-all"
            }
        }
        html2pdf().set(options).from(printElement).save(`${fileName}.pdf`);
    }

    render() {
        const programContainer = this.props.programContainer;
        if (programContainer == null) return null;
        return this.generateHtmlString();
    }

    generateHtmlString = () => {
       
        if (this.props.programContainer.CategoryId?.toUpperCase() == "CMA") {
            return (
                <div className="ontario-row">
                    <CMAFormComponent
                        programContainer={this.props.programContainer}
                        isEng={this.props.isEng}
                        callback={(p) => this.props.callback(p)}
                        callbackValidate={(errors) => {
                            this.setState({ validationErrMsg: errors }, () => {
                                this.props.callback(this.props.programContainer);
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            });
                        }} 
                    />
                </div>
            )
        };
        switch (this.props.programContainer.displayForm) {
            case 'panel':
                return (
                    <>
                        <div style={{ display: this.state.showForm ? "block" : "none" }}>
                            {this.previewForm()}
                            {this.renderConfirmationDialog()}
                            {this.addSubmitAndReview()}
                        </div>
                        <div style={{ display: this.state.showReview ? "block" : "none", marginTop: "5%" }}>
                            {this.generateReviewHtmlString()}
                        </div>
                    </>
                );
            case 'hiddenStepper':
                return (
                    <>
                        <div className="ontario-row">
                            <div>
                                {/* @ts-ignore */}
                                <Toast ref={(el) => this.growl = el} />
                            </div>
                            <div style={{ display: this.state.showForm ? "block" : "none" }}>
                                {this.previewFormInStepper()}
                                {this.continueBtn()}
                            </div>
                            <div style={{ display: this.state.showReview ? "block" : "none" }}>
                                {this.generateReviewHtmlString()}
                            </div>
                        </div>
                    </>
                );
            case 'stepper':
            case 'NoIndicatorStepper':
            case 'hiddenStepperWithSectionTitle':
                return (
                    <>
                        <div>
                            {/* @ts-ignore */}
                            <Toast ref={(el) => this.growl = el} />
                        </div>
                        <div style={{ display: this.state.showForm ? "block" : "none" }}>
                            {this.previewFormInStepper()}
                            {this.renderConfirmationDialog()}
                            <div style={{ display: this.continueButtonHidden ? 'block' : 'none' }}>
                                {this.addSubmitAndReview()}
                            </div>
                            <br />
                            {this.stepperBtn()}
                        </div>
                        <div style={{ display: this.state.showReview ? "block" : "none", marginTop: "5%" }}>
                            {this.generateReviewHtmlString()}
                        </div>
                    </>
                );
            case 'progressBarStepper':
                return (
                    <>
                        <div>
                            {/* @ts-ignore */}
                            <Toast ref={(el) => this.growl = el} />
                        </div>
                        <div style={{ display: this.state.showForm ? "block" : "none" }}>
                            {this.previewFormInStepper()}
                            {this.renderConfirmationDialog()}
                            <div style={{ display: this.continueButtonHidden ? 'block' : 'none' }}>
                                {this.addSubmitAndReview()}
                            </div>
                            {this.stepperBtn()}
                        </div>
                    </>
                );
                break;

            default:
                return (this.previewForm());
        }
    }

    handleRemoveConfirmation = (accept: boolean) => {
        if (accept) {
            this.sectionArray.splice(this.removingIndex, 1);
        }

        this.setState({ showConfirmationDialog: false });
    };

    renderConfirmationDialog = () => {
        const showConfirmationDialog = this.state.showConfirmationDialog;
        return (
            <>
                {/* @ts-ignore */}
                <ConfirmDialog
                    visible={showConfirmationDialog}
                    onHide={() => this.handleRemoveConfirmation(false)}
                    message="Are you sure you want to remove this?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    accept={() => this.handleRemoveConfirmation(true)}
                    reject={() => this.setState({ showConfirmationDialog: false })}
                    closable={false}
                />
            </>
        );
    };

    generateReviewHtmlString = (forDownload: boolean = false) => {
        let ReviewHtmlString = [];
        if (!this.state.showReview) return null;

        if (SectionUtils.HasCustimzedSummary(this.props.programContainer)) {
            const style = this.props.programContainer.ListOfFormSections.filter(p => p.CustomizedReviewPage && p.Visible)?.[0]?.CustomizedStyle;
            ReviewHtmlString.push(
                <CustomizedSummaryComponent programContainer={this.props.programContainer}
                    isEng={this.props.isEng}
                    activesteps={this.activeStepList}
                    style={style}
                    callback={(programContainer) => {
                        this.props.callback(programContainer);
                    }}
                    callbackStepIndex={(stepperIndex) => {
                        let index = stepperIndex
                        if (typeof stepperIndex === "string") {
                            const root = this.props.programContainer;
                            const foundSection = root.ListOfFormSections.find(section => section.ENUTitle == stepperIndex);
                            const indexNum = root.ListOfFormSections.indexOf(foundSection);
                            index = indexNum;
                        }
                        this.activeStepList.add(index);
                        this.setState({ showReview: false, showForm: true, stepperIndex: index });
                    }}
                />
            );
        }
        else {
            this.state.showReview && ReviewHtmlString.push(<SummaryComponent programContainer={this.props.programContainer} isEng={this.props.isEng} />);
            if (forDownload == false) {
                ReviewHtmlString.push(this.addSubmitAndReview())
            }
        }

        return ReviewHtmlString;
    }

    saveToServer = async (isSubmit) => {
        this.setState({isBusy:true});
        try{
            await DataUtils.saveToServer(isSubmit, this.props.programContainer, this.growl);
            this.setState({isBusy:false});
            this.props.callback(this.props.programContainer);
        } catch (ex){
            this.setState({isBusy:false});
        }
    }
}
